<template>
  <v-container fluid>
    <vue-headful title="Stats" description="Online-Service Administration"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">Stats</h1>
        </div>
      </v-col>
    </v-row>
    <p class="headline">DB Stats</p>
    <p>{{db_stats}}</p>
  </v-container>
</template>

<script>
  export default {
    name: 'Service_Stats',
    components: {},
    data() {
      return {
        db_stats: {},
        loading: false,
        reason: '',
        error: false,
      }
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        this.loading = true;
        this.db_stats = await this.$backend.get_stats("db-info");
      },
      onLoadSuccess(data) {
        this.loading = false;
      },
      onLoadError(reason) {
        this.loading = false;
        this.error = true;
        this.reason = reason;
      },
    },
    computed: {},
    watch: {
      // settings_edited: {
      //   deep: true,
      //   handler(o, n) {
      //     this.changed = JSON.stringify(this.settings) !== JSON.stringify(this.settings_edited);
      //   }
      // }
    }
  }
</script>

<style scoped>
</style>
